import { APIFieldType } from '@ardoq/api-types';
import { SurveyEditorSectionKey } from './streams/types';
import { t, type I18nLocale } from '@ardoq/i18n';

export const SURVEY_SECTION_TITLES = {
  detailsSection: 'General information',
  workspaceAndComponentsSection: 'Data selection',
  changeApprovalSection: 'Response approval',
  surveySection: 'Questions',
  permissionsAndVisibilitySection: 'Permissions and Visibility',
  responseFeedback: 'Feedback message',
  resultDisplayOptionsSection: 'Landing page',
  resultFilteringSection: 'Results page',
  discover: 'Ardoq Discover',
};

export const optionalSections: SurveyEditorSectionKey[] = [
  'changeApprovalSection',
  'responseFeedback',
  'resultDisplayOptionsSection',
  'discover',
];

export const SURVEY_SECTION_SUBTITLES = {
  detailsSection:
    'Add details that help respondents understand the purpose of this survey',
  workspaceAndComponentsSection:
    'The survey will be based on a single workspace and component type, but you can add reference questions later that connect to other workspaces or component types.',
  changeApprovalSection:
    "Review the responses submitted on this survey before it becomes a part of your organization's data. This feature is not available for surveys with a tag question",
  responseFeedback:
    'Create a custom message that will be shown to respondents after submission',
  resultDisplayOptionsSection:
    'Respondents will be taken to a landing page first instead of the results page that shows a list existing survey components',
  resultFilteringSection:
    'Customize how the list of survey components is displayed in the results page',
  discover: 'Set up this survey for Ardoq Discover',
};

export const SURVEY_SECTION_STEPTITLES = {
  changeApprovalSection: 'Response approval',
};

export const SECTIONS_WITH_OWN_RENDERER: Set<SurveyEditorSectionKey> = new Set([
  'detailsSection',
  'changeApprovalSection',
  'surveySection',
  'responseFeedback',
  'resultDisplayOptionsSection',
  'discover',
  'permissionsAndVisibilitySection',
]);

export const getNotEnoughWorkspacePermissionsText = (
  permissionLabel: string,
  i18nLocale: I18nLocale
) =>
  t(
    i18nLocale,
    'surveyAdmin:editor.notEnoughWorkspacePermissions',
    { permissionLabel },
    'You do not have "{{permissionLabel}}" access on the workspace this survey has been created on. You can view the survey details, but you will be unable to save any changes.'
  );

export const YOU_DO_NOT_HAVE_EDIT_ACCESS_TO_WORKSPACE =
  'You do not have "Edit" access on the selected workspace';
export const YOU_DO_NOT_HAVE_READ_ACCESS_TO_WORKSPACE =
  'You do not have "Read" access on the selected workspace';

export const APPROVER_FIELD_TYPES = new Set([
  APIFieldType.EMAIL,
  APIFieldType.USER,
]);
